import { render } from "./VehicleInfoComponent.vue?vue&type=template&id=6087761f&ts=true"
import script from "./VehicleInfoComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleInfoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__